// extracted by mini-css-extract-plugin
export default {"heading4":"heading-04_heading4__aT5Bt","semibold":"heading-04_semibold__n4YVG","error":"heading-04_error__GQFdy","underlined":"heading-04_underlined__g8gPh"};